import { StatusColor } from '@enums/status-color.enum';
import { LegalFormalityCreationEnum } from '@legal/legal-core/enums/legal-formality-creation.enum';

export const LEGAL_CREATION_STATUS_COLOR: Record<LegalFormalityCreationEnum, StatusColor> = {
  [LegalFormalityCreationEnum.creationCollectToDo]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationCollectAwaitingCustomer]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationCollectToFix]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationCollectToCheck]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationDepositAwaitingCustomer]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationDepositToInvit]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationDepositNotaryToInform]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationDepositAwaitingNotary]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationStatutesToProduce]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationStatutesToSign]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationStatutesAwaiting]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationStatutesToFix]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationRegistrationAwaitingApproval]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationRegistrationToDo]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationRegistrationToSign]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationRegistrationToPay]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationRegistrationAwaitingOrganism]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationRegistrationToRegularize]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationRegistrationToRedo]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationRegistrationToDoApproval]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationCapitalReleaseRibToRequest]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationCapitalReleaseAwaitingCustomerRib]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationCapitalReleaseAwaitingTiimeRib]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationCapitalReleaseNotaryToInform]: StatusColor.warn,
  [LegalFormalityCreationEnum.creationCapitalReleaseAwaitingNotary]: StatusColor.orange,
  [LegalFormalityCreationEnum.creationCompleted]: StatusColor.accent,
  [LegalFormalityCreationEnum.creationAnomaly]: StatusColor.warn
};
